module.exports = __webpack_public_path__ + "img/regulamento-background-cut.0362bfa2.png";